(() => {
 const root=document.getElementById('aq-respiro-product');if(!root)return;
 const data=JSON.parse(root.querySelector('[data-product-data]').textContent);
 const formatPrice=v=>data.pricePending?'':v.price===null?'Accedi per visualizzare il prezzo':Number(v.price)>0?new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',useGrouping:true,minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(v.price)):'Prezzo su richiesta';
 if(data.mode==='catalogue'){
  function choose(id){
   const variant=data.variants.find(v=>String(v.id)===String(id))||data.variants[0];
   root.querySelector('[data-sku]').textContent=variant.sku?'Cod. '+variant.sku:'';
   root.querySelector('[data-price]').textContent=formatPrice(variant);
   root.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(String(variant.id)===b.dataset.variant)));
   if(variant.image){const hero=root.querySelector('.aq-gallery img');if(hero){hero.src=variant.image;hero.removeAttribute('srcset');}}
   root.querySelector('.aq-contact').href=data.contactUrl+'?product='+encodeURIComponent(data.title+' '+variant.sku+' '+(variant.title==='Default Title'?'':variant.title));
   const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
  }
  root.querySelectorAll('[data-variant]').forEach(b=>b.addEventListener('click',()=>choose(b.dataset.variant)));
  root.querySelectorAll('.aq-document-section').forEach(s=>{s.hidden=!s.querySelector('a[href]');});
  choose(data.selectedVariant);return;
 }
 const finishes=[
  ['steel','Acciaio','steel','#9ca1a5','#f4f4f4','#777b80'],
  ['gold','Gold','pvd','#a68138','#f5dfa2','#b28a40'],
  ['lightgold','Light Gold','pvd','#b7a681','#f3e7c9','#bfae8b'],
  ['copper','Copper Bronze','pvd','#805038','#e9b294','#b77959'],
  ['gun','Gun Metal','pvd','#34383e','#a4a7aa','#555a60'],
  ['black','Black','paint','#181a1b','#181a1b','#181a1b'],
  ['white','White','paint','#efefed','#efefed','#efefed']
 ];
 let media=data.media||{},state={finish:'steel',surface:'polished'};
 const initial=data.variants.find(v=>String(v.id)===String(data.selectedVariant));
 if(initial?.sku.endsWith('X'))state.surface='brushed';
 if(initial?.sku.endsWith('PVD'))state.finish='gold';
 if(initial?.sku.endsWith('VE')){state.finish='black';state.surface='matte';}
 function activeVariant(){
  const suffix=['black','white'].includes(state.finish)?'VE':state.finish==='steel'?(state.surface==='brushed'?'X':'C'):'PVD';
  return data.variants.find(v=>v.sku.endsWith(suffix))||data.variants[0];
 }
 function render(){
  if(['black','white'].includes(state.finish))state.surface='matte';
  else if(state.surface==='matte')state.surface='brushed';
  const variant=activeVariant(),finish=finishes.find(f=>f[0]===state.finish);
  const label=finish[1]+' · '+(state.surface==='brushed'?'Satinato / spazzolato':state.surface==='matte'?'Opaco':state.finish==='steel'?'Specchiato':'Lucido');
  root.querySelector('[data-sku]').textContent='Cod. '+variant.sku;
  const price=root.querySelector('[data-price]');
  price.textContent=formatPrice(variant);
  root.querySelector('[data-selected]').textContent=label;
  root.querySelectorAll('[data-finish]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.finish===state.finish)));
  root.querySelectorAll('[data-surface]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.surface===state.surface)));
  root.querySelector('.aq-surfaces').hidden=state.surface==='matte';
  root.querySelectorAll('[data-view]').forEach(img=>{
   const key=state.finish+'-'+state.surface+'-'+img.dataset.view;
   if(media[key])img.src=media[key];
   img.alt=data.title+' — '+label+' — '+img.dataset.view;
  });
  root.querySelectorAll('[data-image-finish]').forEach(e=>e.textContent=label);
  const contact=root.querySelector('.aq-contact');
  contact.href='https://www.aquademy.it/pages/contact?product='+encodeURIComponent(data.title+' '+variant.sku+' '+label);
  if(!data.sandbox){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);}
 }
 for(const [id,name,family,shade,shine,tone] of finishes){
  const b=document.createElement('button');b.type='button';b.className='aq-swatch';b.dataset.finish=id;b.setAttribute('aria-label',name);b.title=name;
  for(const [key,val] of Object.entries({shade,shine,tone}))b.style.setProperty('--'+key,val);
  b.innerHTML='<span aria-hidden="true"></span><span></span>';b.lastElementChild.textContent=name;
  b.addEventListener('click',()=>{state.finish=id;render();});
  root.querySelector('[data-family="'+family+'"]').append(b);
 }
 root.querySelectorAll('[data-surface]').forEach(b=>b.addEventListener('click',()=>{state.surface=b.dataset.surface;render();}));
 if(data.mediaUrl)fetch(data.mediaUrl).then(r=>{if(!r.ok)throw Error('Media');return r.json();}).then(m=>{media=m;render();}).catch(()=>{});
 root.querySelectorAll('.aq-document-section').forEach(section=>{section.hidden=!section.querySelector('a[href]');});
 render();
})();


